export default __webpack_public_path__ + "static/media/5.b2ae33be.webp";